import { defineMessages } from 'react-intl';

export const commonTwcMessages: {
	completedStatus: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dismissTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	completedStatus: {
		defaultMessage: 'Completed',
		description: 'Status description for showing onboarding completed',
		id: 'growth-starburst.twc-onboarding-widget.onboarding-card.status',
	},

	dismissTooltip: {
		defaultMessage: 'Dismiss',
		description: 'Tooltip for dismissing the onboarding card',
		id: 'growth-starburst.twc-onboarding-widget.onboarding-card.dismiss-tooltip',
	},
});
